<template>
  <container>
    <middle-title style="margin-bottom: 40px" title="全方位金融服务"
      description="辰宇作为全国领先的环球财务规划服务机构，为客户提供海外留学、环球移民、环球房产及家族信托传承等专业服务。" />
    <a-row type="flex" :gutter="[60, 32]">
      <a-col v-for="(service, index) in services" :xxl="12" :xl="12" :lg="12" :md="24" :key="index">
        <div style="display: flex">
          <div style="text-align: center;margin-right: 20px">
            <div class="bg-secondary"
              style="display: inline-block; height: 80px; width: 80px; text-align: center;padding: 25px;margin-bottom: 20px;border-radius: 40px">
              <AccountBookFilled class="text-primary" style="font-size: 30px" />
            </div>
          </div>
          <div>
            <h5>{{ service.title }}</h5>
            <p>{{ service.content }}</p>
          </div>
        </div>
      </a-col>
    </a-row>
  </container>
</template>

<script>
import { AccountBookFilled } from '@ant-design/icons-vue'
import MiddleTitle from '@/components/common/MiddleTitle'
export default {
  name: 'Services',
  components: { MiddleTitle, AccountBookFilled },
  data() {
    return {
      services: [
        // {
        //   title: '环球投资 Global Investment',
        //   content: 'S&P指数保本计划、环球基金储蓄计划、派息型基金计划、香港投资移民、港美股托管服务、新加坡家族办公室'
        // },
        {
          title: '环球房产 Overseas Property',
          content: '专注海外优质住宅、别墅、酒店、酒店式公寓、土地、工业园及各类商业大宗资产项目的投资咨询、项目开发、租赁管理、落地配套、买卖、土地开发、税法咨询、贷款服务等一站式定制化专业服务'
        },
        {
          title: '法务咨询 Legal Consultation',
          content: '企业治理及用工合规、民商事争议解决（含跨境）、投融资及并购交易（含出海）、破产重整、金融证券、知识产权及商业秘密保护、刑事辩护、账款清收及不良资产、婚姻家事法律服务、家族信托及财富规划'
        },
        // {
        //   title: '保险咨询 Insurance Consultation',
        //   content: '重疾险、高端医疗险、美金储蓄分红计划、大额人寿、保单信托项目、养老社区项目'
        // },
        {
          title: '留学教育 Overseas Education',
          content: '常规留学申请、名校高端申请、语言标化提升、科研课题提升、国际竞赛冲刺、名企实习输送、冬/夏令营、导师辅导护航、中小学低龄升学辅助'
        },
        {
          title: '企业出海 Enterprise Service',
          content: '香港秘书服务、全球银行开户、海外公司注册、ODI/37号文/FDI投资、金融牌照办理买卖、粤港两地车牌办理、海外投资架构搭建、CRS税务筹划、企业服务'
        },
        {
          title: '移民规划 Immigration Planning',
          content: '全球26个国家和地区的一站式移民服务，包含投资移民、技术移民、创业移民、购房移民等不同方式，实现环球身份规划'
        },
        {
          title: '家族信托 Family Trust',
          content: '家族信托、境外保险金信托、境外上市前信托、股权信托、移民信托'
        }
      ]
    }
  }
}
</script>

<style scoped></style>
